import { CustomArrowProps } from 'react-slick'

import { StyledArrow } from './index.styled'

export const NextArrow = ({ onClick, className }: CustomArrowProps) => {
  return (
    <StyledArrow onClick={onClick} className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M13.071 12.0002L9.24995 8.17915C8.83595 7.76515 8.83595 7.09315 9.24995 6.67915C9.66395 6.26515 10.336 6.26515 10.75 6.67915L15.364 11.2932C15.755 11.6842 15.755 12.3172 15.364 12.7072L10.75 17.3212C10.336 17.7352 9.66395 17.7352 9.24995 17.3212C8.83595 16.9072 8.83595 16.2352 9.24995 15.8212L13.071 12.0002Z"
          fill="#595959"
        />
      </svg>
    </StyledArrow>
  )
}

export const PreviousArrow = ({ onClick, className }: CustomArrowProps) => {
  return (
    <StyledArrow onClick={onClick} className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M10.929 12.0002L14.75 8.17915C15.164 7.76515 15.164 7.09315 14.75 6.67915C14.336 6.26515 13.664 6.26515 13.25 6.67915L8.63605 11.2932C8.24505 11.6842 8.24505 12.3172 8.63605 12.7072L13.25 17.3212C13.664 17.7352 14.336 17.7352 14.75 17.3212C15.164 16.9072 15.164 16.2352 14.75 15.8212L10.929 12.0002Z"
          fill="#595959"
        />
      </svg>
    </StyledArrow>
  )
}
